import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js'
import axios  from 'axios';
import Cookies from 'universal-cookie';
import {Loader} from './Loader.js';
import {SocialAuth} from './SocialAuth.js';

export class Auth extends Component {

    state = {
        email :'',
        password : '',
        showErrorMsg : false,
        errorMsg : null,
        isSending : false,
    }

    constructor(props) {
        super(props)
        this.props = props
        const cookies = new Cookies();
        if ( (cookies.get('tgsubs_token') != undefined)) {
       
            window.location = '/createwidget'
         }
    }

    doShowErrorMsg ( msg) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   isSending : false,
                   errorMsg : msg,
                   showErrorMsg : true
               };
       }, () =>  {
           
       })
        setTimeout(() => { 
          
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       isSending : false,
                       errorMsg : null,
                       showErrorMsg : false





                    };
           }, () =>  {
               
           })

        }, 2000)
      }

    updateEmailValue = (e) => {
        const updatedInputValue = e.target.value;
        // ...
        
        this.setState((prevState) => {
             return  {
                    email : updatedInputValue
                
                };
        }, () =>  {
            
        })
    
    }

    updatePasswordValue = (e) => {
        
        const updatedInputValue = e.target.value;        
        this.setState((prevState) => {
             return  {
                    password : updatedInputValue
                
                };
        }, () =>  {
            
        })

    }

    
    SendAuthRequest = (e) => {
        const cookies = new Cookies();

        e.preventDefault();
        
        
        this.setState((prevState) => {
            return  {
                   isSending : true
               
               };
       }, () =>  {
           
       })
        axios
        .post(process.env.REACT_APP_BACKEND_SERVER +'/Auth/', {
            'email' : this.state.email,
            
            'password' :  this.state.password,
        },
        /* {headers: {
            'Content-Type': 'multipart/form-data'
        }}*/ )
        .then(res => {
           
            if (process.env.REACT_APP_ENV == 'DEV') {
                cookies.set('tgsubs_token', 
                res.data.access,
                 {path : '/'});
            }
            else {
                cookies.set('tgsubs_token', 
                res.data.access,
                 {path : '/' });
            }
            
            window.location.href = '/createwidget'
        })
        .catch(err => {
            
            this.doShowErrorMsg('логин и/или пароль неправильные')
            
        })
           
    }

    render() {
        return (
            
            <RegWrapper errorMsg={this.state.errorMsg} showErrorMsg={this.state.showErrorMsg}>
            
            <div><h1>Войти</h1></div>
            <Loader loader={this.state.isSending} />
            

            <div class="uk-flex">
                <div><p>Еще нет аккаунта ?</p></div>
                <div style={{fontWeight: 'bold'}}><a style={{marginLeft: '0.675em'}} href='/reg'>
                    Зарегистрируйтесь</a></div>
            </div>
            
            <div class="uk-margin">
                <input class="uk-input  uk-background-muted" 
                type="text" placeholder="E-mail*" value={this.state.email} 
                onChange={e => this.updateEmailValue(e)}/>
            </div>
            <div class="uk-margin">
                <input class="uk-input  uk-background-muted"
                 type="password" placeholder="Пароль*"  
                 value={this.state.password}
                 onChange={e => this.updatePasswordValue(e)} />
            </div>
            
            <div class="main-left-bottom">
                <div class="uk-flex" style={{marginBottom: '1.25em'}} >
                    <div><a href='/restorePassword'>Забыли пароль?</a></div>
                </div>

                {/*<SocialAuth /> */}               
                <button onClick={e => this.SendAuthRequest(e)} 
                className="btn1">Войти</button>
            </div>
      
        </RegWrapper>  

        )
    }

}
